import React from 'react';
import './PolicyPages.css';

const CookiePolicyPage = () => {
    return (
        <div className="policy-page">
            <section className="policy-hero">
                <div className="container">
                    <h1>Çerez Politikası</h1>
                    <p>Web sitemizde çerezlerin nasıl kullanıldığına dair bilgilendirme</p>
                </div>
            </section>

            <div className="container main-policy-container">
                <div className="policy-content">
                    <article className="policy-article">
                        <h2>Çerez Politikası</h2>
                        <p className="policy-update-date">Son Güncelleme: 18 Temmuz 2024</p>

                        <section>
                            <h3>1. Çerez Nedir?</h3>
                            <p>
                                Çerezler, bir web sitesi tarafından tarayıcınıza gönderilen ve bilgisayarınızda veya mobil cihazınızda
                                depolanan küçük metin dosyalarıdır. Çerezler, web sitesinin sizi tanımasını veya tercihlerinizi
                                hatırlamasını sağlayarak kullanıcı deneyiminizi geliştirir.
                            </p>
                        </section>

                        <section>
                            <h3>2. Hangi Çerezleri Kullanıyoruz?</h3>
                            <p>Web sitemizde aşağıdaki çerez türlerini kullanmaktayız:</p>

                            <h4>Zorunlu Çerezler</h4>
                            <p>
                                Web sitesinin temel işlevlerinin çalışması için gereklidir. Bu çerezler olmadan web sitemiz düzgün
                                çalışmaz.
                            </p>

                            <h4>Performans Çerezleri</h4>
                            <p>
                                Ziyaretçi sayısı, trafik kaynakları gibi istatistiksel verileri toplayarak web sitemizin performansını
                                ölçmemize yardımcı olur.
                            </p>

                            <h4>İşlevsellik Çerezleri</h4>
                            <p>
                                Dil tercihleriniz gibi seçimlerinizi hatırlayarak size kişiselleştirilmiş bir deneyim sunmamızı sağlar.
                            </p>

                            <h4>Hedefleme/İzleme Çerezleri</h4>
                            <p>
                                İlgi alanlarınıza uygun reklamların gösterilmesi amacıyla ziyaret ettiğiniz sayfaları ve bağlantıları
                                izlemek için kullanılır.
                            </p>
                        </section>

                        <section>
                            <h3>3. Çerezlerin Kontrol Edilmesi ve Silinmesi</h3>
                            <p>
                                Çerez kullanımını kontrol etmek veya çerezleri silmek isterseniz, tarayıcı ayarlarınız üzerinden bu işlemi
                                gerçekleştirebilirsiniz. Ancak, bazı çerezleri devre dışı bırakmanın web sitemizin işlevselliğini
                                etkileyebileceğini unutmayın.
                            </p>
                            <p>
                                Popüler tarayıcılarda çerez ayarlarını nasıl değiştirebileceğinize dair bilgiler:
                            </p>
                            <ul>
                                <li><strong>Google Chrome:</strong> Ayarlar &gt; Gizlilik ve güvenlik &gt; Çerezler ve diğer site verileri</li>
                                <li><strong>Mozilla Firefox:</strong> Seçenekler &gt; Gizlilik &amp; Güvenlik &gt; Çerezler ve Site Verileri</li>
                                <li><strong>Safari:</strong> Tercihler &gt; Gizlilik &gt; Çerez ve site verilerini yönet</li>
                                <li><strong>Microsoft Edge:</strong> Ayarlar &gt; Gizlilik, arama ve hizmetler &gt; Çerezler ve site izinleri</li>
                            </ul>
                        </section>

                        <section>
                            <h3>4. Üçüncü Taraf Çerezleri</h3>
                            <p>
                                Web sitemizde, Google Analytics, Facebook Pixel gibi üçüncü taraf hizmet sağlayıcıların çerezleri de
                                kullanılmaktadır. Bu çerezler, söz konusu şirketler tarafından doğrudan yönetilmektedir.
                            </p>
                        </section>

                        <section>
                            <h3>5. Çerez Politikasındaki Değişiklikler</h3>
                            <p>
                                Çerez politikamızda zaman zaman değişiklikler yapabiliriz. Yapılan değişiklikler bu sayfada yayınlanacak
                                ve geçerli politikanın en güncel versiyonu olarak kabul edilecektir.
                            </p>
                        </section>

                        <section>
                            <h3>6. İletişim</h3>
                            <p>
                                Çerez politikamızla ilgili herhangi bir sorunuz varsa, lütfen <a href="mailto:info@fiberinternetim.com.tr">info@fiberinternetim.com.tr</a> veya <a href="destek@fiberinternetim.com.tr">destek@fiberinternetim.com.tr</a>
                                adresinden bizimle iletişime geçin.
                            </p>
                        </section>
                    </article>
                </div>
            </div>
        </div>
    );
};

export default CookiePolicyPage;